import { __assign } from "tslib";
import React, { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
var InputElement = forwardRef(function (props, ref) { return React.createElement("span", __assign({ ref: ref }, props)); });
var InputLeftElement = forwardRef(function (props, ref) { return (React.createElement(InputElement, __assign({}, props, { className: twMerge('absolute left-3', props.className), ref: ref }))); });
var InputRightElement = forwardRef(function (props, ref) { return (React.createElement(InputElement, __assign({}, props, { className: twMerge('absolute right-3', props.className), ref: ref }))); });
InputLeftElement.displayName = 'InputLeftElement';
InputRightElement.displayName = 'InputRightElement';
export { InputLeftElement, InputRightElement };
